<template>
    <div class="container sms-wrapper">
        <a-button @click="$refs.smsNotice.show()" type="primary"> <i style="font-size:14px;" class="iconfont icon-jia"></i> 发送短信</a-button>
        <a-alert class="mt20">
            <div class="flex x-between" slot="message">
                <div class="flex x-left y-center">
                    <div class="mr20">可用金额： <b class="error-color">¥{{moneyInfo.balance}}</b></div>
                    <div class="mr20">短信价格： <b class="error-color">¥{{moneyInfo.price}}</b></div>
                    <div class="mr20">可发短信数： <b class="error-color">¥{{moneyInfo.sms_num}}</b></div>
                </div>
                <a href=""><a-button type="primary">在线充值</a-button></a>
            </div>    
        </a-alert>
        <a-table :row-key="(record) => record.id" :loading="tableLoading"  :scroll="{x:1100,y:'calc(100vh - 320px)'}"  @change="handlePaginationChange" :pagination="pagination" class="mt20 table-wrapper" size="small" :data-source="dataList" :columns="columns">
            <!-- <div slot="action" class="t-l" slot-scope="text, record">
                    <a @click="handleEditEvent(record)" href="javascript:;" class="edit-btn iconfont icon-bianji"></a>
                </div> -->
        </a-table>
        <sms-notice @ok="handleSmsOkEvent" ref="smsNotice"></sms-notice>
        <sms-preview @ok="getSmsList" ref="smsPreview"></sms-preview>
    </div>
</template>

<script>
const columns = [
    {
        title: '发送状态',
        dataIndex: 'message_id',
        width:150,
        flex:'left',
    },
    // {
    //     title: '发送目标',
    //     dataIndex: 'target',
    //     width:150,
    //     flex:'left',
    // },
    {
        title: '内容',
        dataIndex: 'content',
    },
    {
        title: '数量（条）',
        dataIndex: 'num',
        width: 100,
        align:'center',
    },
    {
        title: '发送人',
        dataIndex: 'real_name',
        width: 100,
        align:'center',
    },
    {
        title: '发送时间',
        dataIndex: 'send_time',
        width:200,
    },

    // {
    //     title: '操作',
    //     width: 100,
    //     key: 'action',
    //     align: "center",
    //     scopedSlots: { customRender: 'action' },
    // },
];
import smsNotice from '@/components/sms-notice.vue'
import smsPreview from '@/components/preview-sms.vue'
export default {
    name: "smsList",
    components: { smsNotice,smsPreview },
    props: {

    },
    data() {
        return {
            columns,
            dataList: [],
            tableLoading: true,
            pagination:{
                pageSize:20,
                current:1,
                total:0,
                showTotal: total => `共${total}条`,
            },
            moneyInfo:{},
        }
    },
    methods: {
        getSmsList() {
            let { meeting_id } = this.$route.params.meeting_id;
            this.$request.post({ url: 'smsList', data: { meeting_id,limit:this.pagination.pageSize,page:this.pagination.current } }).then(res => {
                this.dataList = res.list;
                this.pagination.total = +res.count;
                this.tableLoading = false;
                document.getElementsByClassName('layout-content')[0].scroll(0,0);
            })
        },

        handlePaginationChange(pagination){
            this.pagination.current = pagination.current;
            this.pagination.pageSize = pagination.pageSize;
            this.getSmsList();
        },

        // 短信预览
        handleSmsOkEvent(data){
            this.$refs.smsPreview.show(data);
        },

        // 获取余额
        getMoney(){
            let { meeting_id } = this.$route.params.meeting_id;
            this.$request.post({url:'getMoney',data:{meeting_id}}).then(res => {
                this.moneyInfo = res.data;
            })
        }
    },
    mounted() {
        this.getSmsList();
        this.getMoney();
    },
}
</script>

<style lang="less" scoped>
.table-wrapper {
    background: #fff;
    /deep/.ant-table-small {
        th,
        td {
            border-color: #cad4ef !important;
        }
        &>.ant-table-content {
            border: 1px solid #cad4ef;
        }
        &>.ant-table-content>.ant-table-body {
            margin: 0;
        }
        .ant-table-thead {
            background-color: #f1f3ff;
        }
    }
}

.error-color{
    color:@danger;
    font-weight: bold;
    font-size:16px;
}
</style>